// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion:hover{
    background-color: #b9bbc1;
    color: rgb(27, 27, 182);
}`, "",{"version":3,"sources":["webpack://./src/components/common/Modals/suggestion.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B","sourcesContent":[".suggestion:hover{\n    background-color: #b9bbc1;\n    color: rgb(27, 27, 182);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
